import { type BaseInputTemplateProps, getInputProps } from '@rjsf/utils'
import { Mtds } from 'prove-common'

export const BaseInputTemplate = ({
  className,
  disabled,
  id,
  onChange,
  options,
  placeholder,
  readonly,
  required,
  schema,
  type,
  value = ''
}: BaseInputTemplateProps) => (
  <Mtds.Input
    className={className}
    disabled={disabled}
    id={id}
    onChange={({ target }) => onChange(target.value)}
    placeholder={placeholder}
    readOnly={readonly}
    required={required}
    value={value}
    {...getInputProps(schema, type as string | undefined, options)}
  />
)
